export const PLANNING_FILTERS_ID = 'planning-filters';

/** Matches sticky header height (py-3 + logo h-20 / md:h-24) */
export const PLANNING_STICKY_TOP_CLASS = 'top-[6.5rem] md:top-[7.5rem]';

function getHeaderScrollOffset() {
  const header = document.querySelector('[data-testid="main-header"]');
  return header?.getBoundingClientRect().height ?? 104;
}

/** Scroll so the filter toolbar sits flush below the sticky site header. */
export function scrollToPlanningFilters() {
  const el = document.getElementById(PLANNING_FILTERS_ID);
  if (!el) return false;

  const offset = getHeaderScrollOffset();
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
  });

  return true;
}

/** Retry scroll until the planning page has mounted. */
export function scheduleScrollToPlanningFilters({ delayMs = 0, maxAttempts = 30 } = {}) {
  let attempts = 0;
  let cancelled = false;
  let timeoutId;
  let rafId;

  const run = () => {
    if (cancelled) return;

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    if (scrollToPlanningFilters()) return;

    attempts += 1;
    if (attempts < maxAttempts) {
      rafId = requestAnimationFrame(run);
    }
  };

  timeoutId = window.setTimeout(() => {
    if (!cancelled) {
      rafId = requestAnimationFrame(run);
    }
  }, delayMs);

  return () => {
    cancelled = true;
    window.clearTimeout(timeoutId);
    if (rafId) cancelAnimationFrame(rafId);
  };
}
